/**
 * The URL segment the email feed lives at under a Clarity domain: `/clarity/d/:domainId/email`.
 *
 * Shared because three layers must agree on it — the application's route, the tab strip's tab id and
 * the badge entry that pairs an unseen count to that tab — and a tab whose id has drifted from the
 * route silently loses its badge, so all three read this one declaration rather than three literals.
 * `type:util` is the one layer all three may reach, and it is how the shell reaches the Email tab
 * without depending on the libraries that implement it.
 */
export const CLARITY_EMAIL_ROUTE_SEGMENT = 'email';
